import { FunctionComponent } from "react";
import { Tooltip } from "antd";

interface DetailItemProps {
  title?: string;
  description: string | JSX.Element | JSX.Element[];
  descriptionBold?: boolean;
  descriptionGrey?: boolean;
  noTooltip?: boolean;
  tooltipLabel?: string;
  bgColor?: string;
  textColor?: string;
  icon?: JSX.Element;
  className?: string;
  index?: number;
  dataTest?: string;
}

const DetailItem: FunctionComponent<DetailItemProps> = ({
  title,
  description,
  descriptionBold,
  descriptionGrey,
  noTooltip = false,
  tooltipLabel,
  bgColor,
  textColor,
  icon,
  className = "",
  index = 0,
  dataTest = undefined,
}) => {
  return (
    <div
      className={`app-item-detail ${
        bgColor ? `has-bg ${bgColor}` : ""
      } ${textColor} ${className}`}
    >
      {title && (
        <div
          data-alt={title?.trim() ?? ""}
          data-test={"input-label"}
          data-test-for={dataTest ?? `detail-item-${index}`}
          className="item-title"
        >
          {title}
        </div>
      )}
      {icon && icon}
      <div
        className={`item-description 
        ${descriptionBold ? "font-weight-bold" : ""}
        ${descriptionGrey ? "text-dark-grey" : ""}
        `}
        data-test={dataTest ?? "input-label"}
      >
        {noTooltip ? (
          description
        ) : (
          <Tooltip
            title={tooltipLabel ? tooltipLabel : description}
            placement="bottom"
          >
            {description}
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default DetailItem;
